import type { Outcome } from '../types.js';

/** Additional hero outcomes for coverage targets (~30 more). */
export const HERO_OUTCOMES_EXTRA: Outcome[] = [
  mk(
    'b01_hero',
    'twist_wrong_hero',
    'hope_low',
    's01_gate',
    'Mira steps aside. The Whisper Gate interviews a passing moth instead. The moth accepts. Canon creaks.',
    'Heroes are interchangeable, apparently.',
    ['overlay_swap'],
  ),
  mk(
    'b02_macguffin',
    'rule_page_stain',
    'fate_low',
    's02_archive',
    'Ink Stain smears the word "forever" into "for now." Vell\'s trade offer expires mid-sentence.',
    'Contracts hate moisture.',
    ['overlay_ink_stain'],
  ),
  mk(
    'b02_macguffin',
    'twist_macguffin_fake',
    'chaos_mid',
    's02_archive',
    'The Candle Crown clicks hollow. Inside: a note that says "nice try." Vell swears professionally.',
    'I hid a decoy. You found it. Rude.',
    ['overlay_fake'],
  ),
  mk(
    'b04_climb',
    'chaos_time_skip',
    'fate_high',
    's04_tower',
    'Time Skip jumps the climb. Mira is suddenly on the roof, confused, winded, victorious by accident.',
    'Stairs are optional if you cheat time.',
    ['overlay_skip'],
  ),
  mk(
    'b05_market',
    'twist_secret_tunnel',
    'hope_mid',
    's05_market',
    'A secret tunnel opens under a vegetable stall. Extras shrug. The riot drains into it like gossip.',
    'Tunnels are lazy writing. Efficient, though.',
    ['overlay_tunnel'],
  ),
  mk(
    'b06_bridge',
    'chaos_storm_indoors',
    'dread_mid',
    's06_bridge',
    'Storm Indoors brings lightning to the bridge. Planks glow. The cruel choice is postponed by weather drama.',
    'Metaphors should not thunder.',
    ['overlay_storm'],
  ),
  mk(
    'b07_villain',
    'twist_frog_curse',
    'chaos_high',
    's07_throne',
    'The crown lowers onto Vell and ribbits. The crowd applauds because crowds love novelty.',
    'I will not describe the sound.',
    ['overlay_frog'],
  ),
  mk(
    'b08_panic',
    'chaos_prophecy_wrong',
    'dread_low',
    's08_reveal',
    'The prophecy typo swaps DOOM for DOOR. Panic becomes carpentry. Everyone feels silly.',
    'Ancient texts need spellcheck.',
    ['overlay_typo'],
  ),
  mk(
    'b09_bard',
    'keep_curse_mark',
    'hope_high',
    's09_storm',
    'Curse Mark glows on Tomas\'s cheek when the narrator lies. He navigates the sacrifice by following the glow away from danger.',
    'I dislike being fact-checked by skin.',
    ['overlay_mark'],
  ),
  mk(
    'b10_wicks',
    'rule_rewind_line',
    'fate_mid',
    's10_choice',
    'Read That Again rewinds the wick scene one line. Mira gets a second breath. The third flame waits, patient.',
    'Encore requested. Encore granted.',
    ['overlay_rewind'],
  ),
  mk(
    'b11_finale',
    'counter_nope',
    'hope_high',
    's11_finale',
    'Nope unwrites the footnote ending. The Narrator\'s victory speech becomes a sticky note: "to revise."',
    'You cannot Nope my epilogue. Watch me.',
    ['overlay_nope'],
  ),
  mk(
    'b12_sequel',
    'chaos_time_skip',
    'chaos_low',
    's12_epilogue',
    'Time Skip leaps past the sequel hook. A single line remains: "Book Two exists. Maybe."',
    'Marketing hates you.',
    ['overlay_skip'],
  ),
  mk(
    'b01_hero',
    'keep_story_debt',
    'fate_low',
    's01_gate',
    'Story Debt sticks to the gatekeeper. They owe Mira a favor before the scene can end.',
    'Favors are currency. Annoying currency.',
    ['overlay_debt'],
  ),
  mk(
    'b03_ballad',
    'chaos_prophecy_wrong',
    'chaos_low',
    's03_bard',
    'The ballad\'s warning misprints. Instead of doom, it predicts soup. Tomas sings it anyway.',
    'Soup is not foreshadowing.',
    ['overlay_typo'],
  ),
  mk(
    'b04_windows',
    'twist_actually_door',
    'hope_mid',
    's04_tower',
    'Each ending window becomes a door. Mira could leave. She does not. Drama demands stairs.',
    'Doors ruin windows. You love doors.',
    ['overlay_door'],
  ),
  mk(
    'b05_extras',
    'twist_helpful_stranger',
    'chaos_mid',
    's05_market',
    'A stranger hands out riot shields shaped like bookmarks. The fight becomes literature.',
    'Stop helping.',
    ['overlay_stranger'],
  ),
  mk(
    'b06_chasm',
    'rule_lie_mode',
    'dread_low',
    's06_bridge',
    'The narrator lies that the chasm is shallow. It is not. Your card forces the lie to become true for three seconds. Long enough.',
    'Physics filed a complaint.',
    ['overlay_lie'],
  ),
  mk(
    'b07_villain',
    'keep_lucky_charm',
    'hope_mid',
    's07_throne',
    'Lucky Charm warms on Mira\'s belt. The Throne of Margins squeaks aside one inch. Enough.',
    'Luck is not furniture polish.',
    ['overlay_charm'],
  ),
  mk(
    'b08_hero',
    'twist_twin',
    'fate_mid',
    's08_reveal',
    'The story strings duplicate. Two sets tug Mira in different directions. She chooses both.',
    'Twins again? Really?',
    ['overlay_twin'],
  ),
  mk(
    'b09_storm',
    'chaos_gravity_off',
    'chaos_high',
    's09_storm',
    'Ink rain floats upward. Sacrifice knives drift past Tomas\'s ears. He laughs, terrified, alive.',
    'Gravity quit before I did.',
    ['overlay_gravity'],
  ),
  mk(
    'b10_silence',
    'rule_skip_intent',
    'hope_low',
    's10_choice',
    'Cut the Foreshadowing silences the bad bargains. Held breath becomes held hope.',
    'Silence is also a weapon.',
    ['overlay_rule_break'],
  ),
  mk(
    'b11_hero',
    'twist_frog_curse',
    'chaos_mid',
    's11_finale',
    'Mira threatens frog curse. The Narrator behaves. Briefly.',
    'Amphibian diplomacy works.',
    ['overlay_frog'],
  ),
  mk(
    'b12_narrator',
    'keep_curse_mark',
    'dread_mid',
    's12_epilogue',
    'The scar in the deck glows with your mark. Next run will remember.',
    'I see your graffiti.',
    ['overlay_mark'],
  ),
  mk(
    'b02_trade',
    'counter_not_yet',
    'dread_low',
    's02_archive',
    'Not Yet delays Vell\'s smile from becoming a deal. Mira reads the room.',
    'Villains hate waiting.',
    ['overlay_delay'],
  ),
  mk(
    'b04_hero',
    'counter_nope',
    'hope_low',
    's04_tower',
    'Nope cancels the trap on the landing. Mira descends smugly. Towers hate smug.',
    'Traps are suggestions.',
    ['overlay_nope'],
  ),
  mk(
    'b06_macguffin',
    'twist_macguffin_fake',
    'fate_high',
    's06_bridge',
    'The Crown on the far side is painted tin. The real one was in Mira\'s pocket the whole time. Classic.',
    'I did not write pocket storage.',
    ['overlay_fake'],
  ),
  mk(
    'b08_hero',
    'twist_wrong_hero',
    'dread_mid',
    's08_reveal',
    'Wrong Hero makes the Narrator the protagonist for one line. They hate it. The strings tangle.',
    'I am not the hero. You are insufferable.',
    ['overlay_swap'],
  ),
  mk(
    'b10_silence',
    'chaos_sudden_festival',
    'chaos_low',
    's10_choice',
    'Festival erupts around the Crown. Wicks become sparklers. Serious endings pout.',
    'Joy is inconvenient.',
    ['overlay_festival'],
  ),
  mk(
    'b11_dim',
    'rule_lie_mode',
    'chaos_mid',
    's11_finale',
    'The narrator lies that this is the end. Credits roll, stutter, roll back. Honest ending pending.',
    'I lied. You enabled it.',
    ['overlay_lie'],
  ),
  mk(
    'b01_gate',
    'chaos_sudden_festival',
    'chaos_low',
    's01_gate',
    'Candle smoke becomes confetti. Gatekeeper dances. Entry granted out of pity.',
    'Sacred gates hate parties.',
    ['overlay_festival'],
  ),
];

function mk(
  beatId: string,
  cardId: string,
  stateKey: string,
  backgroundId: string,
  bridge: string,
  quip: string,
  overlays: string[],
): Outcome {
  const key = `book1_narrator_quits/${beatId}/${cardId}/${stateKey}`;
  return {
    key,
    tier: 'hero',
    bridgeText: bridge,
    narratorQuip: quip,
    effects: [
      { type: 'narrator_glitch', value: 'hero' },
      { type: 'shift_track', target: 'fate', value: 1 },
      { type: 'scene_mood', value: 'tense' },
    ],
    visual: {
      backgroundId,
      mood: 'tense',
      overlayIds: overlays,
      narratorExpression: 'flustered',
      stampEffect: 'stamp_twist',
    },
  };
}
